import remarkGfm from 'remark-gfm'
import { ProtocolSchema } from '../src/Generic/models/Protocol'
import { transformLinkUri } from 'src/util/src/react-markdown'
import ReactMarkdown, { Options } from 'react-markdown'

export function Markdown(props: Options) {
  return <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm]} transformLinkUri={transformLinkUri(ProtocolSchema.options)} {...props}>{props.children}</ReactMarkdown>
}
